module.exports = __webpack_public_path__ + "img/ic-popup-close-black.c4df77a3.svg";